import { makeStyles } from 'tss-react/mui';
import { theme, colors } from '../../theme';

/**
 * Custom hook that defines the styles for the vote component.
 */
const useVoteComponentStyles = makeStyles()(() => ({
  voteContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.padding.s,
  },
  voteButton: {
    padding: theme.padding.xs,
    marginRight: '0.5rem',
    border: '1px solid #ccc',
    borderRadius: theme.borderRadius.s,
    cursor: 'pointer',
    outline: 'none',
  },
  notVotedButton: {
    'backgroundColor': theme.background.dark,
    'color': colors.white,
    'borderColor': theme.background.dark,
    '&:hover': {
      backgroundColor: theme.background.darker,
      borderColor: theme.background.darker,
    },
  },
  voteButtonUpvoted: {
    'backgroundColor': colors.green[400],
    'color': colors.white,
    'borderColor': colors.green[400],
    '&:hover': {
      backgroundColor: colors.green[500],
      borderColor: colors.green[500],
    },
  },
  voteButtonDownvoted: {
    'backgroundColor': colors.red[500],
    'color': colors.white,
    'borderColor': colors.red[500],
    '&:hover': {
      backgroundColor: colors.red[600],
      borderColor: colors.red[600],
    },
  },
  voteCount: {
    fontFamily: theme.fontFamily,
    marginLeft: '0.5rem',
  },
}));

export default useVoteComponentStyles;
